<div class="row" *ngIf="Breadcrumb!=null">
  <div class="col-12 p-0 border-bottom headersize">
    <app-breadcrumb [Breadcrumb]="Breadcrumb" [File_Name]="File_Name"></app-breadcrumb>
  </div>
</div>
<div class="row">
  <div class="col-12"  style="height: 86vh !important;max-width: 100% !important; overflow: auto;">
    <form [formGroup]="AddContentReviewform">
      <div class="row pt-1">
        <div class="col-8">
          <div class="row">
            <div class="col-12" *ngIf="FileType!='Video'" style="height: 77vh !important;overflow: auto;">
              <div class="card">
                <div class="card-body p-1" *ngIf="urlSafe">
                  <div class="no-print" disableContextMenu>
                    <pdf-viewer [src]="urlSafe"
                                  [render-text]="true"
                                  [original-size]="false"
                                  [fit-to-page]="true"
                                  style="height: 70vh !important;overflow: auto;border-bottom: 1px solid #c8c3c3;" 
                                  [external-link-target]="'blank'"
                                  [autoresize]="true"
                                  [zoom-scale]="'page-width'"
                                  [zoom]="zoom_scale"
                                  [render-text-mode]="0"
                                  [show-borders]="true"
                                  [rotation]="Rotate"
                      ></pdf-viewer>
                      </div>
                      <div class="col-12 pt-1">
                        <div class="row">
                        <div class="col-6">
                          <div class="d-flex justify-content-start">
                            <div class="px-1" >
                              <button type="button" class="btn btn-sm" style="
                              padding: 1px;" (click)="Rotation()">Rotate</button>
                            </div>
                          </div>
                        </div>
                          <div class="col-6">
                            <div class="d-flex justify-content-end">
                              <div class="px-1" >
                                <button type="button" class="btn btn-sm" style="
                                padding: 1px;" (click)="zoom(0)">- zoom</button>
                              </div>
                              <div class="px-1">
                                <button type="button" class="btn btn-sm" style="
                                padding: 1px;" (click)="zoom(1)">+ zoom</button>
                              </div>
                            </div>
                          </div>
                      </div>
                      </div>
                </div>
                <div class="card-body p-1 text-center headersize" *ngIf="!urlSafe">No Preview
                </div>
                  </div>
              </div>
           
            <div class="col-12" *ngIf="FileType=='Video'" style="height: 77vh !important;overflow: auto;">
              <div class="card" >
                <div class="card-body p-1" *ngIf="urlSafe1">
                 
                  <!-- <iframe  style="width:100%; height:100%;border-bottom: 1px solid #c8c3c3;" [src]="urlSafe" frameborder="0">
      
                  </iframe> -->
                  <iframe  *ngIf="File_Name=='External URL'" style="height: 70vh;width:100%;border-bottom: 1px solid #c8c3c3;" [src]="urlSafe1" frameborder="0">
            
                  </iframe>
                  <video *ngIf="File_Name!='External URL'" controls class="col-12" style="height: 70vh;width:100%;border-bottom: 1px solid #c8c3c3;;user-select: none;" oncontextmenu="return false;" controlsList="nofullscreen nodownload noremoteplayback noplaybackrate foobar" (click)="toggleVideo()" #videoPlayer>
                    <source style="user-select: none;" [src]="urlSafe1" type="video/mp4" />
                    <source style="user-select: none;" [src]="urlSafe1" type="video/ogg" />
                    <source style="user-select: none;" [src]="urlSafe1" type="video/mov" />
                    Browser not supported
                </video>
       
                </div>
                <div class="card-body p-1 text-center headersize" *ngIf="!urlSafe1">No Preview
                </div>
              </div>
            </div>

          </div>

        </div>
        <div class="col-4">
          <div class="row">
            <div class="col-12" style="height: 77vh !important;overflow: auto;">
              <div class="row">
                <div class="col-6">
                  <div class="p-0 headersize">Review Comment</div>
                </div>
                <div class="col-6">
                  <div class="d-flex justify-content-center">
                  <div class="link" (click)="Rating()" title="Coverage Rating">Coverage Rating</div>
                 </div>
                </div>
    
              </div>
              <div class="row pt-1">
                <div class="col-12">
                  <!-- <app-quill-rte [RTEFlag]="RTEFlag" (GetCommentboxContent)="GetCommentboxContent($event)" [QuestionBodyget]="QuestionBodyget"></app-quill-rte> -->
                  <app-tinymce [RTEFlag]="RTEFlag" (GetCommentboxContent)="GetCommentboxContent($event)" [QuestionBodyget]="QuestionBodyget"></app-tinymce>
                </div>
              </div>
            </div>

          </div>
        
        </div>

      </div>
      <div class="row">
        <div class="col-12">
          <div class="d-flex justify-content-center pt-1 pb-1">
          

            <div class="px-1" *ngIf="Status=='Submitted'||Status=='Under Review'">
              <button type="button"  class="btn btn-sm bg-light border" (click)="AddSubmitReview('Approved')">Approve</button>
            </div>

           

            <div class="px-1" *ngIf="Status=='Submitted'||Status=='Under Review'">
              <button type="button"  (click)="AddSubmitReview('Defer')"
                class="btn btn-sm bg-light border">Deferred</button>
            </div>
            
            <div class="px-1">
              <button type="button" [disabled]="!AddContentReviewform.valid"(click)="AddContentStatus()" class="btn btn-sm bl-btn">Save</button>
            </div>
            <div class="px-1">
              <button type="button" (click)="Cancel()" class="btn btn-sm bg-light border">Cancel</button>
            </div>
            

            <div class="px-1" *ngIf="Status=='Submitted'|| Status=='Under Review'">
              <button type="button"   class="btn btn-sm bg-light border" (click)="AddSubmitReview('Rework')">Suggest Rework</button>
            </div>

            

            <div class="px-1" *ngIf="Status=='Submitted'|| Status=='Under Review'">
              <button type="button"  class="btn btn-sm bg-light border" (click)="AddSubmitReview('Rejected')">Reject</button>
            </div>

             
          </div>
        </div>

      </div>
    <!-- <div class="row pt-1">
     <div class="col-8">
      <div class="row">
        <div class="col-12" *ngIf="FileType!='Video'">
          <div class="card" style="width:875px; height:500px !important; overflow: auto;">
            <div class="card-body p-1" *ngIf="urlSafe">
       
             
              <div class="no-print" disableContextMenu>
                <pdf-viewer [src]="pdfSrc1"
                              [render-text]="true"
                              [original-size]="false"
                              [fit-to-page]="true"
                              style="width: 865px; height:458px;border-bottom: 1px solid #c8c3c3;" 
                              [external-link-target]="'blank'"
                              [autoresize]="true"
                              [zoom-scale]="'page-width'"
                              [zoom]="zoom_scale"
                              [render-text-mode]="0"
                              [show-borders]="true"
                              [rotation]="Rotate"
                  ></pdf-viewer>
                  
                  
                  </div>
                 

                  <div class="col-12 pt-1">
                    <div class="row" style="width:865px;overflow: auto;">

                   
                    <div class="col-5">
                      <div class="d-flex justify-content-around">
                    
          
                        <div class="px-1" >
                          <button type="button" class="btn btn-sm" style="
                          padding: 1px;" (click)="Rotation()">Rotate</button>
                        </div>
            
                       
            
                        
                        
                        
            
                         
                      </div>
                    </div>
                    
                      <div class="col-6">
                        <div class="d-flex justify-content-center">
                    
          
                          <div class="px-1" >
                            <button type="button" class="btn btn-sm" style="
                            padding: 1px;" (click)="zoom(0)">- zoom</button>
                          </div>
              
                         
              
                          <div class="px-1">
                            <button type="button" class="btn btn-sm" style="
                            padding: 1px;" (click)="zoom(1)">+ zoom</button>
                          </div>
                          
                          
              
                           
                        </div>
                      </div>
                    
                  </div>
                  </div>
                 
            </div>
            <div class="card-body p-1 text-center headersize" *ngIf="!urlSafe">No Preview
            </div>
          </div>
        </div>
        <div class="col-12" *ngIf="FileType=='Video'">
          <div class="card" style="width:875px; height:500px !important; overflow: auto;">
            <div class="card-body p-1" *ngIf="urlSafe">
             
              <iframe  style="width:100%; height:100%;border-bottom: 1px solid #c8c3c3;" [src]="urlSafe" frameborder="0">
  
              </iframe>
            
   
            </div>
            <div class="card-body p-1 text-center headersize" *ngIf="!urlSafe">No Preview
            </div>
          </div>
        </div>
      </div>
      
     </div>
    <div class="col-4">
    <div class="row">
      
        <div class="col-12">
          <div class="row ">
        <div class="col-6 pl-0 ">
          <div class="p-0 headersize">Review Comment</div>
        </div>
   
      </div>
      </div>
      
    </div>
   
        <div class="row pt-1">
        
              <app-quill-rte [RTEFlag]="RTEFlag" (GetCommentboxContent)="GetCommentboxContent($event)" [QuestionBodyget]="QuestionBodyget"></app-quill-rte>
            </div>
         
     
    </div>
    
   
    
     
   
        <div class="col-12">
          <div class="d-flex justify-content-center pt-2 pb-1">
          

            <div class="px-1" *ngIf="Status=='Submitted'||Status=='Under Review'">
              <button type="button"  class="btn btn-sm bg-light border" (click)="AddSubmitReview('Approved')">Approve</button>
            </div>

           

            <div class="px-1" *ngIf="Status=='Submitted'||Status=='Under Review'">
              <button type="button"  (click)="AddSubmitReview('Defer')"
                class="btn btn-sm bg-light border">Deferred</button>
            </div>
            
            <div class="px-1">
              <button type="button" [disabled]="!AddContentReviewform.valid"(click)="AddContentStatus()" class="btn btn-sm bl-btn">Save</button>
            </div>
            <div class="px-1">
              <button type="button" (click)="Cancel()" class="btn btn-sm bg-light border">Cancel</button>
            </div>
            

            <div class="px-1" *ngIf="Status=='Submitted'|| Status=='Under Review'">
              <button type="button"   class="btn btn-sm bg-light border" (click)="AddSubmitReview('Rework')">Suggest Rework</button>
            </div>

            

            <div class="px-1" *ngIf="Status=='Submitted'|| Status=='Under Review'">
              <button type="button"  class="btn btn-sm bg-light border" (click)="AddSubmitReview('Rejected')">Reject</button>
            </div>

             
          </div>
        </div>
    </div> -->
    </form>  
      </div>
</div>

<div class="modal fade  show Model_popup1" *ngIf="ContentRatingflag">
  <div class="modal-dialog modal-dialog-centered modal-dialog-Edit3">
    <div class="modal-content">
      <div class="modal-header border Page-Header p-1 py-0">
        <h6 class="HeadContent" id="QuestionTemplatetitle">Rate Topic Coverage</h6>
        <button type="button" class="close" (click)="Rating()"
          style="padding-right: 20px;font-size: 30px;outline: 0;">
          <span aria-hidden="true">&times;</span></button>
      </div>
     
      <div class="modal-body px-3 py-0">
        <app-content-rating (Closepopup)="Closepopup($event)"[studymateriallist1]="studymateriallist1"></app-content-rating>
      
      </div>
    </div>
  </div>
</div>
      
      